/**
 * WARNING: The order of each item in the lists may be used in conditional statements. Add new items at the end of the
 * array in order to not introduce unwanted behavior throughout the application.
 */

/**
 * Step 1
 */
const studyPurposes = ['Research', 'Education', 'Clinical practice', 'Demonstrating or testing', 'Other (specify)'];
const researchTypes = ['Epidemiologic', 'Intervention', 'Clinical', 'Diet assessment methodology', 'Pilot study', 'Other (specify)'];

const FUNDS_YES = { key: 'yes', value: 'Yes' };
const FUNDS_NO = { key: 'no', value: 'No' };
const FUNDS_PENDING = { key: 'pending', value: 'Funding requests/decisions are still in progress' };
const FUNDS_OTHER = { key: 'other', value: 'Other (please specify)' };
const fundsReceivedOptions = [FUNDS_YES, FUNDS_NO, FUNDS_PENDING, FUNDS_OTHER];

const fundingSources = [
	{
		name: 'NIH',
		subCategories: [
			{ name: 'NCI', alias: 'NIH_NCI' },
			{ name: 'NIDDK', alias: 'NIH_NIDDK' },
			{ name: 'NHLBI', alias: 'NIH_NHLBI' },
			{ name: 'NICHD', alias: 'NIH_NICHD' },
			{ name: 'NIA', alias: 'NIH_NIA' },
			{ name: 'Other (specify)', alias: 'NIH_other' }
		]
	},
	{
		name: 'Other US Government Agency',
		subCategories: [
			{ name: 'USDA', alias: 'USDA' },
			{ name: 'CDC', alias: 'CDC' },
			{ name: 'FDA', alias: 'FDA' },
			{ name: 'HRSA', alias: 'HRSA' },
			{ name: 'Other (specify)', alias: 'AGENCY_other' }
		]
	},
	{
		name: 'Other (i.e., university funding, non-profit, please specify)',
		subCategories: []
	}
];
const researcherAffiliations = [
	'Private Practitioner',
	'Government Agency',
	'University / College researcher',
	'University / College student',
	'Managed Care Organization',
	'Contractor',
	'Other (specify)'
];

const CHARACTERISTIC_YOUNG_CHILDREN = { key: 'young_children', value: 'Young children (0-5 yrs)' };
const CHARACTERISTIC_CHILDREN = { key: 'children', value: 'Children (6-18 yrs)' };
const CHARACTERISTIC_ADULTS = { key: 'adults', value: 'Adults (19-74 yrs)' };
const CHARACTERISTIC_OLDER_ADULTS = { key: 'older_adults', value: 'Older adults (75+ yrs)' };
const CHARACTERISTIC_LOW_INCOME = { key: 'low_income', value: 'Low socioeconomic status/low income' };
const CHARACTERISTIC_LOW_LITERACY = { key: 'low_literacy', value: 'Low literacy' };
const CHARACTERISTIC_LESS_THAN_HS_ED = { key: 'less_than_hs', value: 'Less than high school education' };
const CHARACTERISTIC_PREGNANT = { key: 'pregnant', value: 'Pregnant/lactating' };
const CHARACTERISTIC_INTERVIEWER = { key: 'interviewer', value: 'Interviewer-administered' };
const CHARACTERISTIC_OTHER = { key: 'other', value: 'Other (please describe in “Study Description” above)' };

const studyCharacteristics = [
	CHARACTERISTIC_YOUNG_CHILDREN,
	CHARACTERISTIC_CHILDREN,
	CHARACTERISTIC_ADULTS,
	CHARACTERISTIC_OLDER_ADULTS,
	CHARACTERISTIC_LOW_INCOME,
	CHARACTERISTIC_LOW_LITERACY,
	CHARACTERISTIC_LESS_THAN_HS_ED,
	CHARACTERISTIC_PREGNANT,
	CHARACTERISTIC_INTERVIEWER,
	CHARACTERISTIC_OTHER
]

/**
 * Step 2
 */

const STUDY_TOOL_RECORD = { key: 'Record', value: 'RECORD' }
const STUDY_TOOL_RECALL = { key: 'Recall', value: 'RECALL' }

const studyTools = [
	{
		name: 'RECALL STUDY',
		description: 'Report food & drink consumed the previous day',
		icon: 'history'
	},
	{
		name: 'RECORD STUDY',
		description: 'Report food & drink consumed in real time',
		icon: 'online_prediction'
	}
];

/**
 * Step 2 recall
 */
const RECALL_TYPE_SCHEDULED = { key: 'Scheduled', value: 'SCHEDULED' };
const RECALL_TYPE_UNSCHEDULED = { key: 'Unscheduled', value: 'UNSCHEDULED' };
const INTAKE_MIDNIGHT_TO_MIDNIGHT = { key: 'Midnight to Midnight', value: true };
const INTAKE_24_HOURS = { key: 'Last 24 Hours', value: false }

const recallStudyTypes = [RECALL_TYPE_SCHEDULED, RECALL_TYPE_UNSCHEDULED];
const intakeTimeFrames = [INTAKE_MIDNIGHT_TO_MIDNIGHT, INTAKE_24_HOURS];
const loginsAllowedList = ['One login', 'Multiple logins'];
const timeToCompleteList = ['By midnight', 'By 8 am'];

/**
 * Step 2 record
 */
const RECORD_TYPE_CONSECUTIVE = { key: 'Consecutive-day', value: 'CONSECUTIVE_DAY' };
const RECORD_TYPE_SINGLE = { key: 'Single-day', value: 'SINGLE_DAY' };
const recordStudyTypes = [RECORD_TYPE_CONSECUTIVE, RECORD_TYPE_SINGLE];

/**
 * Step 3
 */
const optionalModules = [
	{
		name: 'Location',
		htmlText: 'This module asks the respondent to report where they ate each meal or snack. Adding the location module can improve the reporting of foods, beverages, and supplements. The choices are:<br><ul><li>Home</li><li>Fast food restaurant</li><li>Other restaurant</li><li>Cafeteria</li><li>Bar or tavern</li><li>Work (not in cafeteria)</li><li>Car</li><li>Sports or entertainment venue</li><li>Child care or day care</li><li>School cafeteria</li><li>School, not in cafeteria</li><li>Other</li></ul>'
	},
	{
		name: 'Ate with others',
		htmlText: 'This module asks the respondent to report whether anyone was present at each meal and snack, and if so, was it a family member or someone else.'
	},
	{
		name: 'Source',
		htmlText: 'This module asks the respondent to report where they acquired each food and drink consumed. The choices are:<br><ul><li>Supermarket or grocery store</li><li>Convenience store</li><li>Other store (any type)</li><li>Produce stand, farmer’s market, orchard, or community supported agriculture (CSA) organization</li><li>Fast food or drive-thru restaurant</li><li>Other restaurant, bar or tavern</li><li>School cafeteria</li><li>Other cafeteria</li><li>Grown or caught by you or someone you know</li><li>Sport, recreation, or entertainment venue</li><li>Soup kitchen, shelter, or food pantry</li><li>Street vendor or vending truck</li><li>Vending machine</li><li>Child care center, day care, or camp</li><li>Residential dining facility or adult day care center</li><li>Not applicable</li><li>Other</li><li>Don’t know</li></ul><br>If the Source Module is selected, the location module will automatically be turned on. Source will not be asked for foods and drinks consumed at the following locations: fast food restaurants, other restaurants, bars or taverns, and sports or entertainment venues. Therefore, selecting this module increases respondent burden. Researchers can choose the standard list of sources or contact the ASA24 helpdesk to implement a customized list of sources for a fee.'
	},
	{
		name: 'TV/Computer Use',
		htmlText: 'This module asks the respondent to report if they were watching TV, using a computer, and/or using a mobile device during meals and snacks.'
	},
	{
		name: 'Respondent Nutrition Report',
		htmlText: 'This module allows for a respondent nutrition report to be generated for respondents aged 2 years and older. Respondents are asked to provide their age and sex, and, for females 8 years or older, whether they are pregnant and/or breastfeeding. The report is generated differently for a recall and record. Recall respondents can immediately view the report after completing their report if the researcher provides access. Record respondents must obtain their report directly from the researcher, who is able to access the report from this website.<br><br>To view a sample report, go to <a href="https://epi.grants.cancer.gov/asa24/respondent/asa24-respondent-nutrition-report-english-05212021.pdf" target="_blank" aria-label="ASA24 Nutrition Profile example https://epi.grants.cancer.gov/asa24/respondent/asa24-respondent-nutrition-report-english-05212021.pdf- New Window">https://epi.grants.cancer.gov/asa24/respondent/asa24-respondent-nutrition-report-english-05212021.pdf</a><br>'
	},
	{
		name: 'Sleep',
		htmlText: 'This module allows researchers to examine the association between sleep and dietary intake, timing of eating, and other variables in the context of the 24-hour day.'
	},
	{
		name: 'Supplements',
		htmlText: 'This module asks the respondent to report any supplements taken. The module must be selected if you want respondents to report supplements.'
	}
];
const optionsRNR = ['Display at the end of the recall', 'Do not display at the end of the recall'];

/**
 * Step 4
 * NOTE: one object's icon info is set inside the computed section of CreateStudyPage/index.vue
 */

const tableRowList = [
	{
		name: 'Study name',
		icon: 'lock_open',
		iconColor: '#4CAF50',
		inputVarName: 'studyName',
		location: '1',
		displayCondition: false,
		fieldId: 'form-study-name'
	},
	{
		name: 'Study description',
		icon: 'lock_open',
		iconColor: '#4CAF50',
		inputVarName: 'studyDescription',
		location: '1',
		displayCondition: false,
		fieldId: 'form-study-description'
	},
	{
		name: 'Study characteristics',
		icon: 'lock_open',
		iconColor: '#4CAF50',
		inputVarName: 'studyCharacteristics',
		location: '1',
		displayCondition: false,
		fieldId: 'form-study-characteristics'
	},
	{
		name: 'Study abbreviation',
		icon: 'lock',
		iconColor: '#FB5051',
		inputVarName: 'studyAbbreviation',
		location: '1',
		displayCondition: false,
		fieldId: 'form-study-abbreviation'
	},
	{
		name: 'Purpose of study',
		icon: 'lock_open',
		iconColor: '#4CAF50',
		inputVarName: 'studyPurpose',
		location: '1',
		displayCondition: false,
		fieldId: 'form-study-purpose'
	},
	{
		name: 'Type of research?',
		icon: 'lock_open',
		iconColor: '#4CAF50',
		inputVarName: 'researchType',
		location: '1',
		displayCondition: true,
		fieldId: 'form-research-type'
	},
	{
		name: 'Have funds been received for this study? ',
		icon: 'lock_open',
		iconColor: '#4CAF50',
		inputVarName: 'fundsReceived',
		location: '1',
		displayCondition: true,
		fieldId: 'form-funds-received'
	},
	{
		name: 'Funding source',
		icon: 'lock_open',
		iconColor: '#4CAF50',
		inputVarName: 'fundingSource',
		location: '1',
		displayCondition: true,
		fieldId: 'form-funding-source'
	},
	{
		name: 'Grant or contract number',
		icon: 'lock_open',
		iconColor: '#4CAF50',
		inputVarName: 'contractNum',
		location: '1',
		displayCondition: true,
		fieldId: 'form-contract-num'
	},
	{
		name: 'Researcher affiliation using ASA24',
		icon: 'lock_open',
		iconColor: '#4CAF50',
		inputVarName: 'researcherAffiliation',
		location: '1',
		displayCondition: false,
		fieldId: 'form-researcher-affiliation'
	},
	{
		name: 'Study tool',
		icon: 'lock',
		iconColor: '#FB5051',
		inputVarName: 'studyTool',
		location: '2',
		displayCondition: false,
		fieldId: 'form-study-tool'
	},
	{
		// The icon info is set by filteredTableRowList since it varies by the tool selected
		name: 'Study type',
		icon: '',
		iconColor: '',
		inputVarName: 'studyType',
		location: '2',
		displayCondition: false,
		fieldId: 'form-study-type'
	},
	{
		name: 'ASA24 version',
		icon: 'lock',
		iconColor: '#FB5051',
		inputVarName: 'version',
		location: '2',
		displayCondition: false,
		fieldId: 'form-version'
	},
	{
		name: 'Number of respondents',
		icon: 'lock_open',
		iconColor: '#4CAF50',
		inputVarName: 'respondentNum',
		location: '2',
		displayCondition: false,
		fieldId: 'form-respondent-num'
	},
	{
		name: 'Study start date',
		icon: 'lock_open',
		iconColor: '#4CAF50',
		inputVarName: 'startDate',
		location: '2',
		displayCondition: false,
		fieldId: 'form-start-date'
	},
	{
		name: 'Study end date',
		icon: 'lock_open',
		iconColor: '#4CAF50',
		inputVarName: 'endDate',
		location: '2',
		displayCondition: false,
		fieldId: 'form-end-date'
	},
	{
		name: 'Total number of recalls per respondents',
		icon: 'lock_open',
		iconColor: '#4CAF50',
		inputVarName: 'totalRecallsRespondent',
		location: '2',
		displayCondition: true,
		fieldId: 'form-total-recalls-respondent'
	},
	{
		name: 'Intake time frame',
		icon: 'lock_open',
		iconColor: '#4CAF50',
		inputVarName: 'intakeTimeFrame',
		location: '2',
		displayCondition: true,
		fieldId: 'form-intake-time'
	},
	{
		name: 'Number of logins allowed',
		icon: 'lock_open',
		iconColor: '#4CAF50',
		inputVarName: 'numLoginsAllowed',
		location: '2',
		displayCondition: true,
		fieldId: 'form-num-logins'
	},
	{
		name: 'Time provided to complete recall',
		icon: 'lock',
		iconColor: '#FB5051',
		inputVarName: 'timeToComplete',
		location: '2',
		displayCondition: true,
		fieldId: 'form-time-to-complete'
	},
	{
		name: 'Number of consecutive days',
		icon: 'lock_open',
		iconColor: '#4CAF50',
		inputVarName: 'numConsecutiveDays',
		location: '2',
		displayCondition: true,
		fieldId: 'form-num-consecutive-days'
	},
	{
		name: 'Number of records',
		icon: 'lock_open',
		iconColor: '#4CAF50',
		inputVarName: 'numRecords',
		location: '2',
		displayCondition: true,
		fieldId: 'form-num-records'
	},
	{
		name: 'Optional study modules',
		icon: 'lock_open',
		iconColor: '#4CAF50',
		inputVarName: 'optionalStudyModules',
		location: '3',
		displayCondition: false,
		fieldId: 'none'
	}
];

export default {
	studyPurposes,
	researchTypes,
	fundsReceivedOptions,
	fundingSources,
	researcherAffiliations,
	recallStudyTypes,
	studyTools,
	intakeTimeFrames,
	loginsAllowedList,
	timeToCompleteList,
	recordStudyTypes,
	optionalModules,
	tableRowList,
	optionsRNR,
	RECALL_TYPE_SCHEDULED,
	RECALL_TYPE_UNSCHEDULED,
	RECORD_TYPE_CONSECUTIVE,
	RECORD_TYPE_SINGLE,
	STUDY_TOOL_RECORD,
	STUDY_TOOL_RECALL,
	CHARACTERISTIC_YOUNG_CHILDREN,
	CHARACTERISTIC_ADULTS,
	CHARACTERISTIC_CHILDREN,
	CHARACTERISTIC_INTERVIEWER,
	CHARACTERISTIC_LESS_THAN_HS_ED,
	CHARACTERISTIC_LOW_INCOME,
	CHARACTERISTIC_LOW_LITERACY,
	CHARACTERISTIC_OLDER_ADULTS,
	CHARACTERISTIC_OTHER,
	CHARACTERISTIC_PREGNANT,
	studyCharacteristics,
	FUNDS_YES,
	FUNDS_NO,
	FUNDS_PENDING,
	FUNDS_OTHER,
	INTAKE_MIDNIGHT_TO_MIDNIGHT,
	INTAKE_24_HOURS
}
